import React from "react";
import Form from '../../Form'
import SoloForm from "../../../../Solo/forms/Form"
import { Modal } from '../../../../../../helpers/commonUi'
// import { connect } from "react-redux";


interface DuplicateFormModalProps {
    visible: boolean;
    setvisible: (status: boolean) => void;
    appType: string;
}
let onSubmit: any;
const DuplicateFormModal = ({
    visible,
    setvisible,
    appType
}: DuplicateFormModalProps) => {
    return (
        <Modal
            dataTestId="create_duplicate_form"
            id="createDuplicateForm"
            title='CREATE DUPLICATE FORM'
            visible={visible}
            onCancel={() => {
                setvisible(false);
            }}
            unmountOnCancel={true}
            footer={{
                enable: true,
                okText: 'CREATE',
                cancelText: "CANCEL",
                onOk: () => {
                    onSubmit()
                    setvisible(false);
                }
            }}
        // mode='EditCreate'
        >
            {appType === "assisted" && <Form
                data-test-id="duplicate_form"
                duplicate={true}
                onSubmit={submit => (onSubmit = submit)}
            ></Form>}
            {appType === "solo" && <SoloForm
                duplicate={true}
                onSubmit={(submit: any) => (onSubmit = submit)}>
            </SoloForm>}
        </Modal>
    );
};

export default DuplicateFormModal;
